import styled from 'styled-components'

export const EditExpenseLineItemDrawerContentStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  height: 100%;
  overflow: auto;

  padding: 1rem 2rem;
`
